import Axios from 'axios'
import config from '@/config/config.js'

// const baseUrl = 'http://192.168.119.122:8081/api/codetable'

const baseUrl = config.apiDomain.LC + (config.isProd ? '/b2/ali-personal-service/subsidy/api/' : '/b2/personal-service/subsidy/api/')
// const marriageBaseUrl = API_DOMAIN.LC + IS_PROD ? '/b2/ali-personal-service/subsidy/api/marriage/' : '/b2/personal-service/subsidy/api/marriage/'

const birthSignLinkUrl = baseUrl + 'birth/getMacauPostSignLink'
const marriageSignLinkUrl = baseUrl + 'marriage/getMacauPostSignLink'
const birthSignAndStartWorkflowUrl = baseUrl + 'birth/signAndStartWorkflow'
const marriageSignAndStartWorkflowUrl = baseUrl + 'marriage/signAndStartWorkflow'

// Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {
  birthSignLinkUrl,
  marriageSignLinkUrl,
  birthSignAndStartWorkflowUrl,
  marriageSignAndStartWorkflowUrl,

  //   submitForm (form, cb) {
  //     Axios.post(applyUrl, form).then(
  //       response => {
  //         cb(response)
  //         // console.log(response.status)
  //       },
  //       error => {
  //         console.error(error)
  //         console.error(error.response.data)
  //       }
  //     )
  //   },

  getMacauPostSignLink (form, subsidyUrl, cb) {
    Axios.post(subsidyUrl, form).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        cb(error.response)
      }
    )
  },

  signAndStartWorkflow (form, formCode, eSignOAuthCode, signAndStartWorkflowUrl, cb) {
    Axios.post(signAndStartWorkflowUrl + '/' + formCode + '/' + eSignOAuthCode, form).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        console.error(error)
        console.error(error.response.data)
      }
    )
  }

}
